import React from 'react'
import { dateService } from '../../../services/date';

function MatchQueueBamLink( { bamLink, queueSlug }) {
  const now = dateService.getDateTime()
  const lockOwner = bamLink.match_lock_owner && (
    `${bamLink.match_lock_owner.first_name} ${bamLink.match_lock_owner.last_name}`
  )
  const lock_time_rem = (
    Math.round((Date.parse(bamLink.match_lock_expiration) - now)/60000))

  const lockMessage = (lockOwner && bamLink.match_lock_expiration) &&(
    Date.parse(bamLink.match_lock_expiration) > now) &&(
    `Locked by ${lockOwner} for ${lock_time_rem} more mins`
  )

  const createdTime = dateService.localizeDate(bamLink.datetime_created)

  const createdFmted = `${dateService.formatDisplayDate(createdTime)} ${dateService.formatTime(createdTime)}`

  function sendToMatchPage() {
    const url = `/#/admin/product-match/smartlink-match/${bamLink.bam_link_id}?match_queue=${queueSlug}`
    window.location = url
  }

  return (
    <div className="row">
      <div className="row-container">
        <span className="bam-link-id">
          { bamLink.bam_link_id }
        </span>
        <span className="datetime-created" >
          { createdFmted }
        </span>
        <span className="lock-status" >
          { lockMessage }
        </span>
        <span className="match-page-button">
          <button onClick={sendToMatchPage}>Match Page</button>
        </span>
      </div>
    </div>
  )
}

export default MatchQueueBamLink
